module.exports = __webpack_public_path__ + "img/social-studies-5-en.b4449edc.png";